import RemoteMeetings from "@/views/App/Portal/PrivateCoaching/RemoteDigitalSignature/RemoteMeetings.vue";


const routesPortalPrivateCoachingRemoteSignature = [
    {
        path: 'private-coaching/remote-meetings/:token',
        name: 'pcRemoteMeetings',
        component: RemoteMeetings,
        meta: {
            public: true
        }
    },
];

export default routesPortalPrivateCoachingRemoteSignature;